export default function Proxy (func, self) {
    return function () {
        return func.apply(self, arguments);
    }
}

Proxy.ForGet = function (func, self) {
    return {
        get () {
            return Proxy(func, self);
        }
    }
}